import { render, staticRenderFns } from "./ChartUsersAge.vue?vue&type=template&id=a7a066d2"
import script from "./ChartUsersAge.vue?vue&type=script&lang=js"
export * from "./ChartUsersAge.vue?vue&type=script&lang=js"
import style0 from "./ChartUsersAge.vue?vue&type=style&index=0&id=a7a066d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports